import type { DlpProduct } from './dlpProduct.model';

export type SecondaryMarketDlpProductActions =
  | SecondaryMarketDlpProductFetchRequested
  | SecondaryMarketDlpProductFetched
  | SecondaryMarketDlpProductFetchFailed
  | SecondaryMarketDlpProductFetchProductNotFound;

// ////////////////////////////////////

export function secondaryMarketDlpProductFetchRequested(
  isin: string,
  tabId?: string,
  createTabOnDlpProductFetched?: boolean,
) {
  return {
    type: 'SECONDARY_MARKET_DLP_PRODUCT_FETCH_REQUESTED' as const,
    tabId,
    isin,
    createTabOnDlpProductFetched,
  };
}
export type SecondaryMarketDlpProductFetchRequested = ReturnType<typeof secondaryMarketDlpProductFetchRequested>;

// ////////////////////////////////////

export function secondaryMarketDlpProductFetched(isin: string, data: DlpProduct) {
  return {
    type: 'SECONDARY_MARKET_DLP_PRODUCT_FETCHED' as const,
    isin,
    data,
  };
}
export type SecondaryMarketDlpProductFetched = ReturnType<typeof secondaryMarketDlpProductFetched>;

// ////////////////////////////////////

export function secondaryMarketDlpProductFetchFailed(isin: string, errorMessage: string) {
  return {
    type: 'SECONDARY_MARKET_DLP_PRODUCT_FETCH_FAILED' as const,
    isin,
    errorMessage,
  };
}
export type SecondaryMarketDlpProductFetchFailed = ReturnType<typeof secondaryMarketDlpProductFetchFailed>;

// ////////////////////////////////////

export function secondaryMarketDlpProductFetchProductNotFound(isin: string) {
  return {
    type: 'SECONDARY_MARKET_DLP_PRODUCT_FETCH_PRODUCT_NOT_FOUND' as const,
    isin,
  };
}
export type SecondaryMarketDlpProductFetchProductNotFound = ReturnType<
  typeof secondaryMarketDlpProductFetchProductNotFound
>;
